
import { Component, Vue } from 'vue-property-decorator';
import EditUserAuth from '@/views/pages/users/EditUserAuth.vue';
import EditUserProfile from '@/views/pages/users/EditUserProfile.vue';
import PageHeader from '@/components/layout/PageHeader.vue';

@Component({
  inject: [
    'userRepository',
  ],
  components: {
    EditUserAuth,
    EditUserProfile,
    PageHeader,
  },
})
export default class EditUser extends Vue {
  private loading: boolean = true;

  public async created(): Promise<void> {
    const userId = this.$route.params.userId;
    if (!userId) {
      await this.$router.push({ name: 'users_index' });
      this.$notifications.error('UserId not provided');

      return;
    }
    this.loading = false;
  }
}
